import Vue from "vue";
import Router from "vue-router";
import routes from "@/router/routes";
import { globalSubscribe } from "./afterEach";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});
router.afterEach(globalSubscribe);

export default router;
